import { Fade } from "react-awesome-reveal";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";

export const About = () => {
    return (
        <div className="about_main">
            <Fade className="fade_header" duration={2000}>
                <Header />
            </Fade>
            <div className="about_wrapper">
                <div className="about_photo">
                    <img
                        src="https://res.cloudinary.com/dx9rdmmff/image/upload/v1792938055/Magda/hero/WhatsApp_Image_2026-10-25_at_14.53.56_2_m30zl2.jpg"
                        alt="Magdalena Olszyńska"
                        className="omnie_photo"
                    />
                </div>

                <div className="about_content">
                    <h2>O mnie</h2>
                    <span className="line"></span>
                    <p>
                        Inżynier z wieloletnim doświadczeniem pracy ze
                        szpitalami oraz firmami medycznymi. Jestem absolwentką
                        międzyuczelnianego kierunku{" "}
                        <strong>Inżynieria mechaniczno-medyczna</strong> na
                        Politechnice Gdańskiej oraz Gdańskim Uniwersytecie
                        Medycznym.
                    </p>
                    <p>
                        Od początku mojej kariery zawodowej byłam związana ze
                        szpitalami — przez <strong>10 lat</strong> jako
                        przedstawicielka medyczna firm specjalizujących się w
                        jednorazowym sprzęcie oraz aparaturze medycznej, a
                        następnie przez kolejne <strong>5 lat</strong> jako{" "}
                        <strong>Kierownik działu Aparatury Medycznej</strong> w
                        jednym z największych kompleksów szpitalnych w
                        Województwie Pomorskim.
                    </p>
                    <p>
                        W pracy nauczyłam się nie tylko skutecznej komunikacji,
                        ale przede wszystkim{" "}
                        <strong>rozumienia potrzeb ludzi</strong> i działania
                        zespołowego dla wspólnego dobra. Szpital stał się moim
                        drugim domem — oczywiście w tym pozytywnym znaczeniu 😊.
                    </p>
                    <p>
                        Od samego początku moja praca była związana z{" "}
                        <strong>dużymi projektami</strong> — budowa i
                        wyposażanie szpitali, modernizacje oddziałów,
                        centralnych sterylizacji oraz projekty z{" "}
                        <strong>Ministerstwa Zdrowia</strong>. W każdym
                        przedsięwzięciu stawiam na rzetelność, terminowość i
                        partnerską współpracę.
                    </p>
                    <p>
                        Wiem, jak trudne są czasy, w których realizuje się
                        ogromną liczbę projektów w krótkim czasie. Dlatego
                        oferuję <strong>kompleksową pomoc</strong> w całym
                        procesie realizacji — od analizy potrzeb, przez dobór
                        sprzętu, po kompletne przygotowanie dokumentacji
                        przetargowej.
                    </p>

                    <div className="cta_section">
                        <p>
                            Zapraszam do zakładki{" "}
                            <Link to="/Job">
                                <strong>OFERTA</strong>
                            </Link>
                            , by dowiedzieć się więcej o dostępnych usługach.
                            Jeśli nie masz czasu do stracenia — przejdź od razu
                            do{" "}
                            <Link to="/contact">
                                <strong>KONTAKTU</strong>
                            </Link>
                            .
                        </p>
                        <span className="decor_line"></span>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};
export default About;
